/* eslint-disable */
export const utilities = {
    debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this,
                args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        }
    },

    isIE() {

        var ua = window.navigator.userAgent;

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;

    },

    // Resizing Pics
    async resizeUploads(file, maxWidth) {

        const res = await new Promise((resolve, reject) => {
            const fileReader = new FileReader()
            fileReader.addEventListener('load', e => {
                const img = new Image()
                img.src = e.target.result
                
                img.onload = () => {
                    const ratio = maxWidth / img.width
                    const canvasWidth = maxWidth
                    const canvasHeight = img.height * ratio
                    const elem = document.createElement('canvas')
                    elem.width = canvasWidth
                    elem.height = canvasHeight
                    const ctx = elem.getContext('2d')

                    if(img.width < maxWidth) {
                        resolve(file)
                        return
                    } 
                    ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight)
                    ctx.canvas.toBlob((blob) => {
                        const optimizedFile = new File([blob], `${file.name}`, {
                            name: 'thumbnail',
                            type: 'image/jpg',
                            lastModified: Date.now()
                        })
                        resolve(optimizedFile)
                    })
                }
            })

            fileReader.readAsDataURL(file)
        })

        return res
    },

    // For creating thumbnails
    createThumbnail(file, readerEvent) {
        const img = new Image()
        img.src = readerEvent.target.result

        return new Promise((resolve, reject) => {
            img.onload = () => {
                const maxWidth = 100
                const ratio = maxWidth / img.width
                let canvasWidth = maxWidth,
                    canvasHeight = img.height * ratio
                const elem = document.createElement('canvas')
                elem.width = canvasWidth
                elem.height = canvasHeight

                const ctx = elem.getContext('2d')
                ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight)
                ctx.canvas.toBlob((blob) => {
                    const thumbFile = new File([blob], `${new Date().getTime()}-${file.name.split('.')[0]}_thumbnail.jpg`, {
                        name: 'thumbnail',
                        type: 'image/jpeg',
                        lastModified: Date.now()
                    })

                    const fileReader = new FileReader()
                    fileReader.addEventListener('load', () => {
                        resolve({
                            thumbnailFile: thumbFile,
                            thumbnailUrl: fileReader.result
                        })
                    })
                    fileReader.readAsDataURL(thumbFile)
                }, 'image/jpeg', 1)

            }
        })


    },

    // Username creator
    createUsername(params) {
        const originalName = params.name
        const stamp = params.stamp || new Date().getTime()

        return `${originalName.split(" ").join("")}-${stamp}`
    },

    // Check PWA
    isPWA() {
        return window && window.matchMedia("(display-mode: standalone)").matches;
    },

    getRandom(min, max) {
        return Math.random() * (max - min) + min;
    }

}

export default utilities